<template>
  <div class="architecture-container">
    <div class="block-title">组织架构</div>

    <div class="img-block">
      <img src="~@/assets/zz_jg.png" alt="">
    </div>

    <div class="content-item">
      <div class="title">理事长简介</div>

      <div class="content-box">
        <!-- <div class="left-cc">
          <img class="img-common" src="~@/assets/lsz.jpg" />
        </div> -->
        <div class="right-cc">
          <div class="name">许可先生</div>
          <div class="desc">
            毕业于北京工业大学，2019年6月至今任北京长安投资集团有限公司办公室主任；2024年1月至今任北京长安投资公益基金会理事长。
          </div>
        </div>
      </div>
    </div>

    <div class="content-item">
      <div class="title">秘书长</div>

      <div class="content-box">
        <!-- <div class="left-cc">
          <img class="img-common" src="~@/assets/lsz.jpg" />
        </div> -->
        <div class="right-cc">
          <div class="name">陈晓岑女士</div>
          <div class="desc">
            毕业于中国石油大学（北京），2021年6月至2023年12月任北京长安投资集团有限公司人事经理；2024年1月至今任北京长安投资公益基金会秘书长。
          </div>
        </div>
      </div>
    </div>

    <!-- TODO: -->
    <div class="lsh">
      <hr>
      <p>侯守法先生，副理事长，北京长安投资集团有限公司董事长</p>
      <p>张秀丽，理事，北京长安投资集团有限公司副总经理</p>
      <p>张超，理事，北京长安投资集团有限公司财务总监</p>
      <p>张珣，副秘书长，北京长安投资集团有限公司行政经理</p>
      <p>李霞，监事，北京长安投资集团有限公司资金经理</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  created() {

  }
}
</script>

<style lang="scss">
.architecture-container {
  .content-item {
    margin-bottom: 30px;

    .title {
      font-weight: bold;
      font-size: 20px;
      padding-bottom: 10px;
      border-bottom: 2px solid #e5e7eb;
      margin-bottom: 15px;
      color: #0A1121;
    }

    .content-box {
      display: flex;
      align-items: flex-end;
      .left-cc {
        width: 300px;
        flex-shrink: 0;
        img {
          
        }
      }

      .right-cc {
        flex-grow: 1;
        // margin-left: 15px;
        
        .name {
          font-size: 18px;
          color: #0A1121;
          font-weight: bold;
          margin-bottom: 15px;
        }

        .desc {
          font-size: 16px;
          color: #0A1121;
        }
      }
    }
  }

  .lsh {
    p {
      font-size: 14px;
      line-height: 50px;
      color: #222;
    }
  }
}
</style>
